import React from 'react';

import { Box } from '@mui/material';

import IKImage from '../../../../components/IKImage/IKImage';
import { HEADER_IMG_SRC_SET } from '../../../DiscoverPage/const';
import useStyles from '../../styles';

interface ImageBackgroundProps {
  preview: string;
  hasSubscription: boolean;
  title?: string;
}

const ImageBackground: React.FC<ImageBackgroundProps> = ({ preview, title, hasSubscription }) => {
  const classes = useStyles(hasSubscription)();

  return (
    <Box className={classes.imgWrapper} data-testid="imageBackground">
      <IKImage
        className={classes.img}
        path={preview}
        alt={title}
        srcset={HEADER_IMG_SRC_SET}
        sizes="100vw"
        draggable={false}
      />
      <Box className={classes.topGradient} />
    </Box>
  );
};

export default ImageBackground;
